import { Resource } from '@ekuaibao/fetch'
import { get } from 'lodash'

const invoiceAction = new Resource('/api/v2/invoice')
const PASSENGER_TRANSPORT_NORM_TYPE = 'INVOICE_PASSENGER_TRANSPORT_IDENTITY_CHECK'
const PASSENGER_TRANSPORT_DETAIL_PREFIXES = ['*运输服务*', '*交通运输服务*']
let passengerTransportNormPromise = null

export function getPassengerTransportNorm() {
  if (!passengerTransportNormPromise) {
    passengerTransportNormPromise = invoiceAction
      .GET('/usageNorm')
      .then(res => {
        const items = res?.items || []
        return items.find(item => item?.normType === PASSENGER_TRANSPORT_NORM_TYPE) || null
      })
      .catch(err => {
        console.error(err)
        passengerTransportNormPromise = null
        return null
      })
  }
  return passengerTransportNormPromise
}

export function isPassengerTransportInvoice(invoice, norm) {
  if (!norm?.active) return false
  const master = invoice?.master || invoice
  if (master?.entityId !== 'system_发票主体') return false

  const invoiceType = get(master, 'form.E_system_发票主体_发票类别')
  const invoiceTypes = norm?.invoiceType || []
  if (invoiceTypes.length && !invoiceTypes.includes(invoiceType)) return false

  const projectNames = norm?.passengerTransportProjectNames || []
  if (!projectNames.length) return false

  return (invoice?.details || []).some(detail => {
    const detailName = (detail?.name || get(detail, 'form.E_system_发票明细_name', '') || '').replace(/\s+/g, '')
    const detailPrefix = PASSENGER_TRANSPORT_DETAIL_PREFIXES.find(prefix => detailName.startsWith(prefix))
    if (!detailPrefix) return false
    const projectDetailName = detailName.slice(detailPrefix.length)
    return projectNames.some(projectName => {
      const normalizedProjectName = (projectName || '').replace(/\s+/g, '')
      return normalizedProjectName && projectDetailName.includes(normalizedProjectName)
    })
  })
}
